export type ResignationReason =
  | "휴직"
  | "퇴사"
  | "파견"
  | "병동이동"
  | null;

/** 대상 병동 Select: 미선택(상위 `targetGroupId`는 `""`) */
export const REASON_TARGET_GROUP_NONE_SELECT_VALUE =
  "__reason_target_group_none__";

export interface ReasonPanelProps {
  joiningDate: string;
  startDate: string;
  onStartDateChange: (value: string) => void;
  isStartDateError?: boolean;
  resignationDate: string;
  onResignationDateChange: (value: string) => void;
  isEndDateError?: boolean;
  targetGroupId?: string;
  onTargetGroupIdChange?: (value: string) => void;
  isTargetGroupError?: boolean;
  memo?: string | null;
  onMemoChange: (value: string) => void;
  /** 대상 병동 Select에서 제외할 그룹 ID (보통 간호사 소속 병동) */
  excludeTargetGroupId?: string | null;
  disabled?: boolean;
  /** true면 GET /groups/by-office 로 대상 병동 목록 (수간호사·HN 등) */
  useOfficeGroupsForTarget?: boolean;
  /** `useOfficeGroupsForTarget` 일 때 office_id 쿼리 파라미터 */
  officeIdForTargetGroups?: string | null;
  /** 파견 다건 입력용 리스트 */
  dispatchActivities?: Array<{
    assignmentId?: number;
    startDate: string;
    endDate: string;
    memo: string | null;
    targetGroupId: string;
  }>;
  onDispatchActivitiesChange?: (
    next: Array<{
      assignmentId?: number;
      startDate: string;
      endDate: string;
      memo: string | null;
      targetGroupId: string;
    }>
  ) => void;
  /** 다른 사유 배정이 이미 차지한 구간(양끝 포함) — date picker disabled 공통 규칙 */
  occupiedRanges?: Array<{
    startDate: string;
    endDate: string;
  }>;
}
